
import Vue from "vue";
import msDataProvider from "../../services/msDataProvider";

export default Vue.extend({
  data() {
    return {
      overtime: false,
    };
  },
  created() {
    msDataProvider.watchData(
        "sdpConnected",
        (value) => {
          if (value) {
            this.$router.push("/prepare").catch((e) => e);
          }
        },
        this
    );
    const self = this;
    setTimeout(() => {
      self.overtime = true;
    }, 5000);
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
